import React from 'react';
import './Footer.css';
import Logo from './Logo';

const Footer = () => {
  return (
    <footer className="footer">
      <div className="footer-container">
        <div className="footer-content">
          <div className="footer-section">
            <div className="footer-logo">
              <Logo />
            </div>
            <p className="footer-description">
              Empowering individuals to master their emotions and create a more peaceful world 
              through proven anger management techniques and tools.
            </p>
          </div>
          
          <div className="footer-section">
            <h3>Quick Links</h3>
            <ul className="footer-links">
              <li><a href="#tools">Tools</a></li>
              <li><a href="#techniques">Techniques</a></li>
              <li><a href="#breathing">Breathing Exercise</a></li>
              <li><a href="#journal">Anger Journal</a></li>
              <li><a href="#resources">Resources</a></li>
            </ul>
          </div>
          
          <div className="footer-section">
            <h3>Support</h3>
            <ul className="footer-links">
              <li><a href="#emergency">Emergency Contacts</a></li>
              <li><a href="#professional">Professional Help</a></li>
              <li><a href="#crisis">Crisis Resources</a></li>
              <li><a href="#community">Community Support</a></li>
            </ul>
          </div>
          
          <div className="footer-section">
            <h3>Connect</h3>
            <div className="social-links">
              <button className="social-link" aria-label="Facebook">
                📘
              </button>
              <button className="social-link" aria-label="Twitter">
                🐦
              </button>
              <button className="social-link" aria-label="Instagram">
                📷
              </button>
              <button className="social-link" aria-label="YouTube">
                📺
              </button>
            </div>
            <p className="contact-info">
              📧 info@peacefulmind.com<br />
              📞 1-800-PEACE-HELP
            </p>
          </div>
        </div>
        
        <div className="footer-bottom">
          <div className="footer-bottom-content">
            <p>&copy; 2024 Peaceful Mind. All rights reserved.</p>
            <div className="footer-bottom-links">
              <a href="#privacy">Privacy Policy</a>
              <a href="#terms">Terms of Service</a>
              <a href="#disclaimer">Disclaimer</a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer; 